import { Controller } from "react-hook-form";
import { ContentPageEditProps } from ".";
import Form from "../Form";
import FormFieldErrors from "../Form/FormFieldErrors";
import PolicyContentInput from "../Inputs/PolicyContentInput";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import { useSiteState } from "../../utils/useSiteState";

const ContentPageEditPolicy: React.FC<ContentPageEditProps> = ({ page }) => {
  const { site } = useSiteState();

  const getDefaults = () => {
    const { content, page_template_config } = page;

    return {
      content,
      page_template_config,
    };
  };

  const onSubmit = async (responseData: any) => {
    // await fetchUser();
    toast("Page content updated", { type: "success" });
  };
  return (
    <Form
      getDefaults={getDefaults}
      onCompleted={onSubmit}
      buttonTitle="Update Content"
      endpoint={`sites/${site.id}/pages/${page.id}`}
      method="put"
      className="w-full text-white"
      render={({ errors, control }) => (
        <>
          <div className="mb-4 mt-6">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Introduction Content
            </label>
            <div className="quileditor bg-gray-600 rounded-lg overflow-hidden focus-within:border-white border border-gray-600">
              <Controller
                name="content"
                control={control}
                defaultValue=""
                rules={{
                  required: false,
                }}
                render={({ field: { onChange, value } }: any): JSX.Element => (
                  <ReactQuill value={value} onChange={onChange} />
                )}
              />
            </div>

            <FormFieldErrors errors={errors} field="content" />
          </div>

          <div className="mb-4 mt-6">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Terms sections
            </label>

            <Controller
              name="page_template_config.sections"
              control={control}
              defaultValue={[]}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <PolicyContentInput value={value} onChange={onChange} />
              )}
            />

            <FormFieldErrors errors={errors} field="content" />
          </div>
        </>
      )}
    />
  );
};

export default ContentPageEditPolicy;
